import { Add, Download, ModeEdit } from "@mui/icons-material";
import { Alert, Button, Grid, LinearProgress, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { CSVLink } from "react-csv";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ListsTemplate } from "../../../constants/csvTemplates";
import defaultColDef from "../../../constants/defaultColDef";
import List from "../../../interface/list";
import { getLists } from "../../../services/api.service";
import { useState } from "react";
import { SelectionChangedEvent } from "ag-grid-community";
import ListDetailDialog from "../../Detail/ElectionDialogs/ListDetailDialog";

function ListsDashboard(): JSX.Element {
    const params = useParams();
    const navigate = useNavigate();
    const id = params.id ? parseInt(params.id) : 0;
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [selectedList, setSelectedList] = useState<List>();

    const { data: lists, error, isLoading } = useQuery<List[]>(["election-lists", { id }], async () => await getLists(id));

    const handleModalClose = () => setModalOpen(false);

    const onSelectionChanged = (event: SelectionChangedEvent) => {
        const selectedRows: List[] = event.api.getSelectedRows();
        setSelectedList(selectedRows.length ? selectedRows[0] : undefined);
    }
    
    if (error) return <Alert severity="error">Error Loading</Alert>;
    if (isLoading) return <LinearProgress />;

    if (lists) {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={8}>
                    <Typography variant={"h5"}>Listen</Typography>
                </Grid>
                <Grid item xs={12} md={4} display="flex" justifyContent="end">
                    <CSVLink
                        data={lists}
                        filename={`${id}-lists.csv`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Button variant="contained" startIcon={<Download />}>CSV Export</Button>
                    </CSVLink>
                    <CSVLink
                        data={ListsTemplate}
                        filename={`template-lists.csv`}
                        target="_blank"
                        style={{ textDecoration: "none" }}
                    >
                        <Button sx={{ml: 1}} variant="contained" startIcon={<Download />}>CSV Template</Button>
                    </CSVLink>
                    {selectedList && <Button sx={{ml: 1}} variant="contained" color="success" onClick={() => setModalOpen(true)}><ModeEdit /></Button>}
                    <Button sx={{ml: 1}} variant="contained" onClick={() => navigate(`/election/${id}/lists/create`)}><Add /></Button>
                </Grid>
                <Grid item xs={12}>
                    <div className="ag-theme-alpine" style={{ width: "100%", height: "70vh" }}>
                        <AgGridReact
                            rowData={lists}
                            rowSelection="single"
                            defaultColDef={defaultColDef}
                            onSelectionChanged={onSelectionChanged}
                            columnDefs={[
                                { field: 'id' },
                                { field: 'name' },
                                { field: 'partyColor' },
                                { field: 'partyName' },
                                { field: 'partyShortname' },
                                { field: 'wahl' },
                                { field: 'kanton' },
                                { field: 'bezirksname' },
                                { field: 'bezirksNr' }
                            ]}
                        />
                    </div>
                </Grid>
                <ListDetailDialog
                    open={modalOpen}
                    list={selectedList}
                    onClose={handleModalClose}
                />
            </Grid>
        );
    }

    return <></>

}


export default ListsDashboard;